// extracted by mini-css-extract-plugin
export var breadcrumb = "_8-2";
export var breadcrumbArrow = "_8-3";
export var breadcrumbs = "_8-0";
export var link = "_8-4";
export var small = "_8-1";